import { bl_fi_stmt_account_run_hdr_RowClass } from '../../../dbschema/bl_fi_stmt_account_run_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class StatementOfAccountRunHdrModel extends BaseContainerModel {
  bl_fi_stmt_account_run_hdr: bl_fi_stmt_account_run_hdr_RowClass = new bl_fi_stmt_account_run_hdr_RowClass();
}